import type { SelectedUsbDac } from './usbDacNames';
import { isSystemAudioZone } from './localZoneStorage';

type LocalZoneLike = {
  type?: string;
  id?: string;
  name?: string;
  metadata?: { audio_device_id?: string };
} | null | undefined;

/**
 * Resolve the OS device name/id passed to exclusive_play IPC.
 * local-native zones use metadata.audio_device_id (cpal/CoreAudio name), not the hashed zone id.
 */
export function resolveExclusiveDeviceName(
  zone: LocalZoneLike,
  selectedUsbDac: SelectedUsbDac | null | undefined,
): string | null {
  if (zone?.type === 'local-native') {
    const fromMeta = zone.metadata?.audio_device_id;
    if (fromMeta) return fromMeta;
    if (zone.name) return zone.name;
    return null;
  }
  // System Audio must never exclusive-route via a remembered USB DAC.
  if (isSystemAudioZone(zone)) {
    return null;
  }
  if (selectedUsbDac?.id) return selectedUsbDac.id;
  return null;
}

export function logLocalOutputExclusive(
  device: string,
  sampleRate: number,
  bitDepth: number,
): void {
  console.log(
    `[local-out] path=exclusive device="${device}" rate=${sampleRate} bits=${bitDepth}`,
  );
}

export function logLocalOutputShared(
  device: string,
  reason: string,
): void {
  console.log(
    `[local-out] path=shared reason=${reason} device="${device}"`,
  );
}

export function logLocalOutputAutoDefault(zoneName: string): void {
  console.log(`[local-out] auto-default → bit-perfect zone ${zoneName}`);
}

export function logLocalOutputNoDac(): void {
  console.log('[local-out] no USB DAC detected → System Audio');
}
